import { QR_CODE_STATE_KEYS } from "constants/contactless";
import get from "lodash/get";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import { useFormikContext } from "formik";

const ApplyToAll = () => {
  const { values, setValues, touched, setTouched } = useFormikContext();

  return (
    <div
      className="f7 fw6 link color-primary link__decoration--hover pt2 pointer"
      onClick={() => {
        const dotColor = get(values, QR_CODE_STATE_KEYS.DOT_OPTIONS_COLOR);
        const clonedValues = cloneDeep(values);
        const clonedTouched = cloneDeep(touched);
        // Corners - square
        set(
          clonedValues,
          QR_CODE_STATE_KEYS.CORNERS_SQUARE_OPTIONS_COLOR,
          dotColor
        );
        set(
          clonedTouched,
          QR_CODE_STATE_KEYS.CORNERS_SQUARE_OPTIONS_COLOR,
          true
        );
        // Corners - dots
        set(
          clonedValues,
          QR_CODE_STATE_KEYS.CORNERS_DOT_OPTIONS_COLOR,
          dotColor
        );
        set(clonedTouched, QR_CODE_STATE_KEYS.CORNERS_DOT_OPTIONS_COLOR, true);
        setTimeout(() => {
          setValues(clonedValues);
          setTouched(clonedTouched);
        }, 0);
      }}
    >
      Apply to all
    </div>
  );
};
export default ApplyToAll;
